{
  "title": "Атлас Астероидов",
  "loading": {
    "progress": "Загрузка Земли..."
  },
  "navigation": {
    "title": "Навигация по координатам",
    "latitude": "Шир:",
    "longitude": "Долг:",
    "latitude_placeholder": "Широта",
    "longitude_placeholder": "Долгота",
    "go_to_location": "Перейти к местоположению",
    "add_marker": "Добавить маркер",
    "my_location": "📍 Моё местоположение",
    "quick_locations": "Быстрые местоположения:",
    "click_instruction": "Нажмите на Землю, чтобы получить координаты этой точки"
  },
  "locations": {
    "london": "Лондон",
    "tokyo": "Токио",
    "washington": "Вашингтон",
    "new_york": "Нью-Йорк",
    "paris": "Париж",
    "rio_de_janeiro": "Рио-де-Жанейро",
    "cairo": "Каир",
    "mumbai": "Мумбаи",
    "moscow": "Москва",
    "cape_town": "Кейптаун",
    "beijing": "Пекин",
    "los_angeles": "Лос-Анджелес",
    "dubai": "Дубай",
    "singapore": "Сингапур",
    "reykjavik": "Рейкьявик",
    "greenwich": "Гринвич (0°,0°)",
    "null_island": "Остров Ноль (0°,0°)"
  },
  "countries": {
    "united_states": "Соединённые Штаты",
    "united_kingdom": "Великобритания",
    "japan": "Япония",
    "australia": "Австралия",
    "france": "Франция",
    "brazil": "Бразилия",
    "egypt": "Египет",
    "india": "Индия",
    "russia": "Россия",
    "south_africa": "Южная Африка",
    "china": "Китай",
    "united_arab_emirates": "Объединённые Арабские Эмираты",
    "singapore": "Сингапур",
    "iceland": "Исландия",
    "canada": "Канада",
    "germany": "Германия",
    "italy": "Италия",
    "spain": "Испания",
    "mexico": "Мексика",
    "argentina": "Аргентина",
    "chile": "Чили",
    "peru": "Перу",
    "colombia": "Колумбия",
    "venezuela": "Венесуэла",
    "norway": "Норвегия",
    "sweden": "Швеция",
    "finland": "Финляндия",
    "denmark": "Дания",
    "netherlands": "Нидерланды",
    "belgium": "Бельгия",
    "switzerland": "Швейцария",
    "austria": "Австрия",
    "poland": "Польша",
    "czech_republic": "Чешская Республика",
    "hungary": "Венгрия",
    "romania": "Румыния",
    "bulgaria": "Болгария",
    "greece": "Греция",
    "turkey": "Турция",
    "israel": "Израиль",
    "saudi_arabia": "Саудовская Аравия",
    "iran": "Иран",
    "iraq": "Ирак",
    "afghanistan": "Афганистан",
    "pakistan": "Пакистан",
    "bangladesh": "Бангладеш",
    "sri_lanka": "Шри-Ланка",
    "myanmar": "Мьянма",
    "thailand": "Таиланд",
    "vietnam": "Вьетнам",
    "cambodia": "Камбоджа",
    "laos": "Лаос",
    "malaysia": "Малайзия",
    "indonesia": "Индонезия",
    "philippines": "Филиппины",
    "south_korea": "Южная Корея",
    "north_korea": "Северная Корея",
    "mongolia": "Монголия",
    "kazakhstan": "Казахстан",
    "uzbekistan": "Узбекистан",
    "kyrgyzstan": "Кыргызстан",
    "tajikistan": "Таджикистан",
    "turkmenistan": "Туркменистан",
    "ukraine": "Украина",
    "belarus": "Беларусь",
    "lithuania": "Литва",
    "latvia": "Латвия",
    "estonia": "Эстония",
    "new_zealand": "Новая Зеландия",
    "papua_new_guinea": "Папуа — Новая Гвинея",
    "fiji": "Фиджи",
    "somalia": "Сомали",
    "ethiopia": "Эфиопия",
    "kenya": "Кения",
    "tanzania": "Танзания",
    "uganda": "Уганда",
    "rwanda": "Руанда",
    "democratic_republic_of_the_congo": "Демократическая Республика Конго",
    "angola": "Ангола",
    "zambia": "Замбия",
    "zimbabwe": "Зимбабве",
    "botswana": "Ботсвана",
    "namibia": "Намибия",
    "madagascar": "Мадагаскар",
    "mauritius": "Маврикий",
    "seychelles": "Сейшельские Острова",
    "morocco": "Марокко",
    "algeria": "Алжир",
    "tunisia": "Тунис",
    "libya": "Ливия",
    "sudan": "Судан",
    "chad": "Чад",
    "niger": "Нигер",
    "mali": "Мали",
    "burkina_faso": "Буркина-Фасо",
    "ghana": "Гана",
    "ivory_coast": "Кот-д'Ивуар",
    "nigeria": "Нигерия",
    "cameroon": "Камерун",
    "gabon": "Габон",
    "central_african_republic": "Центральноафриканская Республика"
  },
  "regions": {
    "africa": "Африка",
    "europe": "Европа",
    "asia": "Азия",
    "north_america": "Северная Америка",
    "south_america": "Южная Америка",
    "oceania": "Океания",
    "antarctica": "Антарктида",
    "middle_east": "Ближний Восток",
    "caribbean": "Карибы",
    "central_america": "Центральная Америка",
    "eastern_europe": "Восточная Европа",
    "western_europe": "Западная Европа",
    "northern_europe": "Северная Европа",
    "southern_europe": "Южная Европа",
    "southeast_asia": "Юго-Восточная Азия",
    "east_asia": "Восточная Азия",
    "south_asia": "Южная Азия",
    "central_asia": "Центральная Азия",
    "western_asia": "Западная Азия",
    "northern_africa": "Северная Африка",
    "eastern_africa": "Восточная Африка",
    "western_africa": "Западная Африка",
    "southern_africa": "Южная Африка",
    "central_africa": "Центральная Африка"
  },
  "coordinates": {
    "format": "{{lat}}°, {{lon}}°",
    "clicked": "Координаты клика: {{lat}}, {{lon}}",
    "your_location": "Ваше местоположение: {{lat}}, {{lon}} (±{{accuracy}}м)",
    "found_location": "Найдено ваше местоположение!\\nКоординаты: {{lat}}°, {{lon}}°",
    "found_location_region": "Найдено ваше местоположение в {{region}}!\\nКоординаты: {{lat}}°, {{lon}}°",
    "latitude": "Широта",
    "longitude": "Долгота",
    "region": "Регион",
    "distance_to_target": "Расстояние до цели",
    "north": "С",
    "south": "Ю",
    "east": "В",
    "west": "З"
  },
  "measurements": {
    "kilometers": "км",
    "meters": "м",
    "accuracy": "±{{value}}м"
  },
  "errors": {
    "geolocation_not_supported": "Геолокация не поддерживается этим браузером.",
    "location_permission_denied": "Доступ к местоположению запрещён пользователем.",
    "location_unavailable": "Информация о местоположении недоступна.",
    "location_timeout": "Время ожидания запроса местоположения истекло.",
    "location_unknown": "Произошла неизвестная ошибка при получении местоположения.",
    "invalid_coordinates": "Пожалуйста, введите корректные значения широты и долготы",
    "location_lookup_failed": "Не удалось найти местоположение"
  },
  "ui": {
    "language": "Язык",
    "select_language": "Выберите язык",
    "control_panel": "Симулятор столкновения астероида",
    "target_coordinates": "Целевые координаты",
    "asteroid_params": "Параметры астероида",
    "diameter": "Диаметр (м)",
    "speed": "Скорость (м/с)",
    "density": "Плотность (кг/м³)",
    "angle": "Угол удара (°)",
    "launch_asteroid": "Запустить астероид",
    "impact_zones": "Зоны воздействия",
    "impact_energy": "Энергия удара",
    "crater_zone": "Кратер (100% разрушение)",
    "fireball_zone": "Огненный шар (50% смертность)",
    "seismic_zone": "Сейсмическая (Meff 7.0)",
    "impact_location": "Место удара"
  },
  "info": {
    "asteroid_info": "Информация об астероиде",
    "earth_info": "Информация о Земле",
    "loading_data": "Загрузка данных..."
  }
}